import { httpCreate } from './http';
import env from './config';

const http = httpCreate('/srv/user');

export const user = {
	childAccountList(params) {
		return http.get('/childAccountList', { params });
	},
	addChildAccount(body) {
		return http.post('/addChildAccount', body);
	},
	updateChildAccount(id, body) {
		return http.put(`/updateChildAccount/${id}`, body);
	},
	forbidden(id, body) {
		return http.put(`/forbidden/${id}`, body);
	},
	delChildAccount(ids) {
		return http.delete('/delChildAccount', { data: ids });
	},
	//获取用户角色权限数据
	empowerRole(userId) {
		return http.get(`/empower/${userId}`);
	},
	viewVideoDialog() {
		return http.post('/viewVideoDialog');
	},
	avatarUpload(data) {
		return http.post('/avatarUpload', data);
	},
	getUserInfo(params) {
		// 目的是为了刷新数据的时候防止读取缓存
		return http.get('/getUserinfo', params ? { params } : null, true);
	},
	// pageNum, pageSize, orderBy, isEnd, date
	//获取用户详情
	getActivityPc(params) {
		return http.get('/getActivity', { params });
	},
	getActivity(uid, params) {
		return http.get(`/getActivity/${uid}`, { params });
	},
	getImpowerActivity(params) {
		return http.get('/getImpowerActivity', { params });
	},
	// pageNum, pageSize, orderBy
	getWatchList(params) {
		return http.get('/getWatchList', { params });
	},
	verifyCode() {
		return location.origin + '/srv/user/verifyCode?' + Math.random();
	},
	checkVerifyCode(params) {
		return http.get('/checkVerifyCode', { params });
	},

	forgetPwdSendSmsCode(data) {
		return http.post('/forgetPwd/sendSmsCode', data);
	},
	forgetModifyPwd(data) {
		return http.post('/forgetPwd', data);
	},
	changePWD(data) {
		return http.post('/changePWD', data);
	},
	// mobPhone
	sendMessage(params) {
		return http.get('/sendMessage', { params });
	},
	// 获取关联直播间短信验证码
	senSmsdMessage(activityId) {
		return http.get(`/sendMessage/${activityId}`);
	},
	updateActiveUser(data) {
		return http.post('/updateActiveUser', data);
	},
	getUserInfoDetail(userId) {
		return http.get('/' + userId);
	},
	getDetail(userId) {
		return http.get('/getDetail/' + userId);
	},
	resetPWD(data) {
		return http.post('/resetPWD', data);
	},
	// newPhone, smsCode
	updatePhone(params) {
		return http.get('/updatePhone', { params });
	},
	addUser(data) {
		return http.post('/addUser', data);
	},
	changeUserPWD(userId, data) {
		return http.post('/changePWD/' + userId, data);
	},
	updateUserInfo(userId, data) {
		return http.post('/' + userId, data);
	},
	login(data) {
		return http.post('/login', data);
	},
	logout() {
		return http.get('/logout');
	},
	getApplicationsList(params, data) {
		return http.post('/getApplicationsList', data, { params });
	},
	getAuthorize(uid, data) {
		return http.get(`/getAuthorize/${uid}`, data);
	},
	managerUpdateUserInfo(userId, data) {
		return http.post(`/${userId}`, data);
	},
	//管理员
	getUserList(data, params) {
		return http.post('', data, { params });
	},
	getAuthorizerAppid() {
		return http.get('/getAuthorizerAppid');
	},
	//根据用户名或手机号搜索
	getByUsernameOrPhone(username) {
		return http.get('/getByUsernameOrPhone', {
			params: { username },
		});
	},
	// 获取加入的企业列表
	getCompanyList(params) {
		return http.get('/getCompany', { params });
	},
	// 双十一的运营活动
	doubleElevenIsGive(params) {
		return http.get('/isGive', { params });
	},
	// 618的活动
	sisxGive(params) {
		return http.get('/sixIsGive', { params });
	},
	// 直播间观众排行榜（前10）
	getUvList() {
		return http.get('/activity/uvList');
	},
	doLogin(body) {
		return http.post('/doLogin', body);
	},
	doSmsLogin(body) {
		return http.post('/smsLogin', body);
	},
};
